import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.png';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import BusquedaController from '../controllers/busqueda.controller';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import actions from '../redux/actions';

const Buscador: React.FC = () => {

    const [texto, setTexto] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [toast, setToast] = useState<any>();
    const dispatch = useDispatch();
    const history = useHistory();
    // const storeState = useSelector(state => state);
    // const elementosCarrito = storeState.elementosCarrito;

    useEffect(() => {
        dispatch({ type: actions.RESET_RESULTS })
    }, [])

    const buscar = async () => {
        if (texto) {
            setLoading(true);
            BusquedaController.buscar(texto).then((respuesta) => {
                const { data } = respuesta;
                const { success, totalDocumentos, result } = data;
                if (success && totalDocumentos > 0) {
                    dispatch({ type: actions.SET_RESULTS, payload: { terminoConsulta: texto, totalDocumentos, result } });
                    setLoading(false)
                    history.push('/resultados');
                } else {
                    setLoading(false)
                    toast.show({ severity: 'error', summary: 'No hay resultados', detail: 'No se encontraron resultados para su consulta' });
                }
            }).catch(err => {
                console.log(err);
                setLoading(false);
            })
        }
    }

    const handleKeyPress = (target: any) => {
        if (target.charCode === 13) {
            buscar()
        }
    }

    return <>
        <div className="AppContent">
            <Toast ref={(el) => setToast(el)} />
            <img src={logo} className="App-logo" alt="logo" />
            <br />
            <span className="p-input-icon-left InputBusquedaContainer">
                <i className="pi pi-search" />
                <InputText placeholder='Buscar' className='InputTextBusqueda'
                    onChange={(e: any) => setTexto(e.target.value)}
                    onKeyPress={(e) => handleKeyPress(e)} />
            </span>
            <div className="Botones">
                <Button label='Buscar' style={{ width: '100%' }}
                    onClick={buscar} />
                <Button label='Avanzada' className='p-button-info' style={{ width: '100%' }} />
            </div>
            {
                loading ?
                    <ProgressSpinner style={{ marginTop: 10 }} />
                    : null
            }
            <div className='Footer'>
                2020 - Sistema de Consulta de Jurisprudencia de la Rama Judicial. Todos los derechos reservados
            </div>
        </div>
    </>
}

export default Buscador;